import { Box } from "@mui/material";
import Header from "components/Header";
import React from "react";
import { useGetSpecificEnquiryQuery } from "state/api";
import ViewEnquiryPageButtons from "./ViewEnquiryPageButtons";
import CustomerDetails from "./CustomerDetails";
import EnquiryTimeline from "./EnquiryTimeline";
import Loader from "components/Loader";
import { useSearchParams } from "react-router-dom";

const ViewEnquiries = () => {
  // get id from search params
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const { data, isLoading } = useGetSpecificEnquiryQuery(id);

  return (
    <Box m="1.5rem 2.5rem">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Header
            title={`Enquiry For ${data?.carCompany} ${data?.carName}`}
            subtitle={<CustomerDetails data={data} />}
            button={
              data.enquiryStatus !== "Closed" && (
                <ViewEnquiryPageButtons id={id} data={data} />
              )
            }
          />
          {isLoading && <p>Loading...</p>}
          <EnquiryTimeline data={data.followUps} />
        </>
      )}
    </Box>
  );
};

export default ViewEnquiries;
